import { render, staticRenderFns } from "./suketLainnya.vue?vue&type=template&id=6714a08a&"
import script from "./suketLainnya.vue?vue&type=script&lang=js&"
export * from "./suketLainnya.vue?vue&type=script&lang=js&"
import style0 from "./suketLainnya.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QAvatar,QBtn,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QDialog,QCard,QCardSection,QFile,QMarkupTable,QCardActions,QInput,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QAvatar,QBtn,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QDialog,QCard,QCardSection,QFile,QMarkupTable,QCardActions,QInput})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
